var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSignal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 4.5H19.5V19.5H21V4.5Z",
    fill: "#1956A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.25H13.5V19.5H15V8.25Z",
    fill: "#1956A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 12H8.25V19.5H9.75V12Z",
    fill: "#1956A8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15H3V19.5H4.5V15Z",
    fill: "#1956A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignal);
export default __webpack_public_path__ + "static/media/icon_signal.d2bfb69a02c7054e75329b46af03a1db.svg";
export { ForwardRef as ReactComponent };